import {
  Box,
  Fab,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import BottomHeader from './Bottom';
import { FC } from 'react';
import useQueryUrl from 'src/hooks/useQuery';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import TooltipCustomize from 'src/components/TooltipCustomize';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ModalManageObjectRetail from '../../ModalManageObjectRetail';
import ObjectPreviewRetail from '../../ObjectPreviewRetail';
import GroupObjectRetail from '../../GroupObjectRetail';
import ComparationToggleButton from 'src/components/ComparationToggleButton';
import { reducerUpdateIsComparation } from 'src/features/sosmedComparison';

interface Props {
  onClickBack: () => void;
}

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: white;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

const HeaderWrapperSec = styled(Box)(
  ({ theme }) => `
    background: #F5F5F5;
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    justify-content: space-between;
    width: 100%;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

const HeaderComparisonDashboardRetail: FC<Props> = ({ onClickBack }) => {
  const query = useQueryUrl();
  const dispatch = useAppDispatch();
  const title = query.get('title');
  const sourceType = query.get('sourceType');
  const theme = useTheme();
  const objectListByObjectType = useAppSelector(
    (state) => state.objectManagement.objectListByObjectType
  );
  const matchesUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isComparation = useAppSelector(
    (state) => state.storeComparison.isComparation
  );

  const onClickComparationButton = () => {
    dispatch(reducerUpdateIsComparation(!isComparation));
  };

  return (
    <>
      <HeaderWrapper display="flex" alignItems="center">
        <Grid container>
          <Grid item lg={12}>
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ mb: 2 }}
              >
                <Fab
                  sx={{
                    background: theme.palette.common.white,
                    border: `1px solid ${theme.palette.grey[200]}`
                  }}
                  size="small"
                  onClick={() => onClickBack()}
                >
                  <ArrowBackIcon />
                </Fab>
                <Stack direction="row" alignItems="center">
                  <Typography
                    variant="h1"
                    sx={{
                      mr: 1
                    }}
                  >
                    {title}
                  </Typography>
                  <TooltipCustomize
                    title={
                      'Comparison analysis between each object, group of object or label'
                    }
                    placement="top-start"
                  >
                    <InfoOutlinedIcon
                      fontSize="small"
                      sx={{ transform: 'translateY(-4px)' }}
                    />
                  </TooltipCustomize>
                </Stack>
              </Stack>
              <Box>
                <ComparationToggleButton
                  isActive={isComparation}
                  onClick={onClickComparationButton}
                />
              </Box>
            </Stack>
          </Grid>
          {sourceType === 'label' && (
            <>
              <Grid item lg={12}>
                <Box mt={2}>
                  <GroupObjectRetail />
                </Box>
              </Grid>
              <Grid item lg={12}>
                <Stack
                  direction={matchesUpSm ? 'row' : 'column'}
                  alignItems={matchesUpSm ? 'center' : 'start'}
                  spacing={1}
                  mt={1.5}
                  mb={3}
                >
                  <ModalManageObjectRetail title="Social Profile" />
                  <ObjectPreviewRetail objectList={objectListByObjectType} />
                </Stack>
              </Grid>
            </>
          )}
        </Grid>
      </HeaderWrapper>
      <HeaderWrapperSec display="flex" alignItems="center">
        <Grid container>
          <Grid item sm={12} width="100%">
            <BottomHeader key={title} />
          </Grid>
        </Grid>
      </HeaderWrapperSec>
    </>
  );
};

export default HeaderComparisonDashboardRetail;
